import { initButtonCarousels } from "./carousels.js";
import { initNewsletter } from "./newsletter.js";

function boot() {
  initButtonCarousels();
  initNewsletter();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}